module.exports = __webpack_public_path__ + "img/heritage.557e3548.webp";